import React, { useState, useEffect } from "react";

import { GeneralModal, Datepicker, FormInput_text, Dropdown } from "components";

import { func_validation } from "functions";
import useMobileLicenseKey from "dataflow/billingPortal/actions/useMobileLicenseKey.actions";


export function useAddLicense({ comId, packageNameList }) {

    const { generateLicense } = useMobileLicenseKey();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [packageName, setpackageName] = useState();
    const [trialExpiryDate, settrialExpiryDate] = useState();

    function updateModalState(visible) {
        setIsModalVisible(visible)
    }

    useEffect(() => {
        if(!isModalVisible) {
            setpackageName(undefined)
            settrialExpiryDate(undefined)
        }
    }, [isModalVisible])

    let modalDisplay = (
        <GeneralModal
            modalWapperClassName={"mobile-license-key__addLicenseModal"}
            isModalVisible={isModalVisible}

            title={"Insert Info"}
            headerClassName={"mobile-license-key__addLicenseModal-header"}
            updateParentState={setIsModalVisible}

            bodyWrapperClassName={"mobile-license-key__addLicenseModal-bodyWrapper"}
            contentClassName={"mobile-license-key__addLicenseModal-content"}
            content={(
                <>
                    <FormInput_text
                        className={"company_ID"}
                        inputLabel={"Company ID"}
                        inputValue={comId}
                        isInputDisabled
                    />
                    <Dropdown
                        className={"mt-4 mb-4"}
                        options={(func_validation.isArrayNotEmpty(packageNameList))? packageNameList.map((obj) => {
                            let packageId = obj?.packageName? obj.packageName:"";
                            let packageName = obj?.packageName? obj?.packageName:"";

                            return {
                                label: packageName,
                                value: packageId
                            };
                        }):""}
                        selectedValue_default={packageName}
                        onChange={(value, label) => {
                            setpackageName(value)
                        }}
                        label={"Product Name"}
                        isLabelLegend isSearchable isClearable isInputRequired
                        isResetRequired={isModalVisible}
                    />
                    <Datepicker
                        isInputRequired
                        label={"Trial Expiry Date"}
                        defaultDate={trialExpiryDate}
                        handleOnChange={settrialExpiryDate}
                        isResetRequired={isModalVisible}
                        otherOptions={{
                            minDate: new Date()
                        }}
                    />
                </>
            )}

            footerClassName={"mobile-license-key__addLicenseModal-footer"}
            confirmButtonText={"Add"}
            footerCancelWrapperClassName={"px-2"}
            footerCancelClassName={"mobile-license-key__addLicenseModal-footer__cancel-button"}
            footerConfirmWrapperClassName={"px-2"}
            cancelButtonText={"Cancel"}
            handleOnConfirm={() => {
                if(func_validation.isNotNullUndefined(packageName) || func_validation.isNotNullUndefined(trialExpiryDate)) {
                    generateLicense(comId, packageName, trialExpiryDate)
                    setIsModalVisible(false)
                }
            }}
            isCancelButtonVisible isConfirmButtonVisible
        />
    );

    return {
        modalDisplay,
        updateModalState
    }
}